<template>
  <div>
    <office v-for="(office, index) in offices" :key="index" :office="office"
      :class="{ 'mt-4': index > 0, 'border-b': offices.length > 1 }"
      :isExpanded="offices.length == 1">
    </office>
  </div>
</template>

<script>
import Office from '@/components/Office'

export default {
  name: 'offices',
  components: { Office },
  props: [ 'offices' ]
}
</script>
